// extracted by mini-css-extract-plugin
export default {"radio":"RadioButton_radio__m44zG","radio-label":"RadioButton_radio-label__faS5g","ptm-radio":"RadioButton_ptm-radio__YL4Z-","ptm-radio-label":"RadioButton_ptm-radio-label__hpfjJ"};